export enum TextAndButtonAlignment {
  TopLeft = '1',
  TopRight = '2',
  MiddleLeft = '3',
  MiddleRight = '4',
  BottomLeft = '5',
  BottomRight = '6',
}
